import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddressLookupSelectDialogComponent } from '../../../Views/Work/Accounts/proprietary/dialogs/selection-dialog/address-lookup-select-dialog/address-lookup-select-dialog.component';
import { AddressSelectDialogComponent } from '../../../Views/Work/Accounts/proprietary/dialogs/selection-dialog/address-select-dialog/address-select-dialog.component';
import { CitySelectDialogComponent } from '../../../Views/Work/Accounts/proprietary/dialogs/selection-dialog/city-select-dialog.component';

@Injectable()
export class SelectionDialogService {
    constructor(private modalService: NgbModal) { }

    public selectCity(options: string[], county: string, state: string): Promise<boolean> {
        const modalRef = this.modalService.open(CitySelectDialogComponent, {
            centered: true,
            size: 'lg',
            backdrop: 'static',
            windowClass: 'ep-modal-search-dialog',
            keyboard: false
        });
        modalRef.componentInstance.options = options;
        modalRef.componentInstance.county = county;
        modalRef.componentInstance.state = state;

        return modalRef.result;
    }

    public selectAddress(addresses: any[]): Promise<boolean> {
        const modalRef = this.modalService.open(AddressSelectDialogComponent, {
            centered: true,
            size: 'lg',
            backdrop: 'static',
            windowClass: 'ep-modal-search-dialog',
            keyboard: false
        });
        modalRef.componentInstance.addresses = addresses;
        return modalRef.result;
    }

    public selectLookupAddress(enteredAddress: any, addresses: any[]): Promise<any> {
        if (enteredAddress && addresses && addresses.length == 1) {
            if (
                enteredAddress.Address_Line_1 == addresses[0].Address_Line_1 &&
                (enteredAddress.Address_Line_2 ?? '') == (addresses[0].Address_Line_2 ?? '') &&
                (enteredAddress.Address_Line_3 ?? '') == (addresses[0].Address_Line_3 ?? '') &&
                enteredAddress.City == addresses[0].City &&
                enteredAddress.State == addresses[0].State &&
                enteredAddress.Zip == addresses[0].Zip
            ) {
                let data = { Event: 'V', Address: addresses[0] };
                return new Promise((resolve) => {
                    resolve(data);
                });
            }
        }

        const modalRef = this.modalService.open(AddressLookupSelectDialogComponent, {
            centered: true,
            size: 'lg',
            backdrop: 'static',
            windowClass: 'ep-modal-search-dialog',
            keyboard: false
        });
        modalRef.componentInstance.addresses = addresses;
        modalRef.componentInstance.enteredAddress = enteredAddress;
        return modalRef.result;
    }
}
